import React from "react";
import styled from "@emotion/styled";
import { failIfValidOrNonExhaustive } from "./Table";
import { dataViz, mediaBelow } from "@atlas-int/tokens";

export enum Fill {
  None,
  Half,
  Full,
  InvertedNone,
  InvertedFull,
}

const filledColor = dataViz.neutral;
const invertedColor = "white";

const diamondSize = 17;

const Root = styled.svg`
  width: ${diamondSize}px;
  height: ${diamondSize}px;
  display: block;
  overflow: visible;

  &:not(:first-child) {
    margin-left: 5px;
  }

  ${mediaBelow("xxl")} {
    width: 13px;
    height: 13px;

    &:not(:first-child) {
      margin-left: 3px;
    }
  }

  ${mediaBelow("tableCompact")} {
    width: 10px;
    height: 10px;

    &:not(:first-child) {
      margin-left: 2px;
    }
  }
`;

interface Props {
  fill: Fill;
}

const Diamond = ({ fill }: Props) => {
  let strokeColor: string = filledColor;
  let fullFillColor: string | undefined;
  let leftHalfFillColor: string | undefined;

  if (fill === Fill.None) {
    // outline only
  } else if (fill === Fill.Half) {
    leftHalfFillColor = filledColor;
  } else if (fill === Fill.Full) {
    fullFillColor = filledColor;
  } else if (fill === Fill.InvertedNone) {
    strokeColor = invertedColor;
  } else if (fill === Fill.InvertedFull) {
    strokeColor = invertedColor;
    fullFillColor = invertedColor;
  } else {
    failIfValidOrNonExhaustive(fill, "Invalid fill " + fill);
  }

  // Diamond on a 12x12 viewBox: top (6,0), right (12,6), bottom (6,12), left (0,6).
  // 0.5px inset keeps the 1px stroke fully inside the viewBox.
  const points = "6,0.5 11.5,6 6,11.5 0.5,6";
  // Left half-fill triangle: top -> bottom -> left.
  const leftHalfPoints = "6,0.5 6,11.5 0.5,6";

  return (
    <Root viewBox="0 0 12 12" shapeRendering="geometricPrecision">
      {fullFillColor !== undefined && (
        <polygon points={points} fill={fullFillColor} />
      )}
      {leftHalfFillColor !== undefined && (
        <polygon points={leftHalfPoints} fill={leftHalfFillColor} />
      )}
      <polygon
        points={points}
        fill="none"
        stroke={strokeColor}
        strokeWidth={1}
      />
    </Root>
  );
};

export default Diamond;
